module.exports = __webpack_public_path__ + "static/the-hydrogen-sonata-d7c2860f412c663cd1ed74a0f989da62.jpg";